import { createSlice } from '@reduxjs/toolkit';
import { getStorageItem, setStorageItem } from 'locale';

const LOCAL_STORAGE_KEY = 'UI_THEME';

export const enum UiTheme {
  LIGHT = 'light',
  DARK = 'dark'
}

export interface UiThemeProps {
  theme: UiTheme;
}

const applyUiTheme = (theme: UiTheme) => {
  document.documentElement.classList.remove(UiTheme.LIGHT, UiTheme.DARK);
  document.documentElement.classList.add(theme);
};

const isDarkModePrefered = false;
const storedUiTheme = getStorageItem(LOCAL_STORAGE_KEY) as UiTheme;

if (!storedUiTheme) {
  setStorageItem(LOCAL_STORAGE_KEY, isDarkModePrefered ? UiTheme.DARK : UiTheme.LIGHT);
}

applyUiTheme(storedUiTheme || (isDarkModePrefered ? UiTheme.DARK : UiTheme.LIGHT));

const initialState: UiThemeProps = {
  theme: (getStorageItem(LOCAL_STORAGE_KEY) as UiTheme) || UiTheme.LIGHT
};

export const uiThemeSlice = createSlice({
  name: 'uiTheme',
  initialState,
  reducers: {
    toggleUiTheme: state => {
      const theme = state.theme === UiTheme.LIGHT ? UiTheme.DARK : UiTheme.LIGHT;

      applyUiTheme(theme);

      setStorageItem(LOCAL_STORAGE_KEY, theme);
      state.theme = theme;
    },
    clearModal: () => {
      return initialState;
    }
  },
  selectors: {
    getUiThemeSelector: state => state.theme
  }
});

export const { toggleUiTheme, clearModal } = uiThemeSlice.actions;
export const { getUiThemeSelector } = uiThemeSlice.selectors;
